export default __webpack_public_path__ + "static/media/refresh.c9eb09b6.png";